import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import {
  HeaderContainer as HeaderContainerComponent,
  MapListSwitcher
} from '@spotahome/ui-library';

import './Header.scss';
import { Mediator } from '@spotahome/soyuz-mediator';

import { TOGGLE_SPOTTY_CAT } from '../common/utils/channels';

const Header = ({ deviceType, onSwitcherClick }) => {
  const IterateSEOLayoutExperient = useSoyuzExperiment('IterateSEOLayout');

  const toggleSpottyCat = () => Mediator.publish(TOGGLE_SPOTTY_CAT);
  return (
    <header
      className={classNames('header', {
        'header--redesign': deviceType === 'desktop'
      })}
    >
      <HeaderContainerComponent
        showLogin
        links={{ changeCity: true }}
        renderExtraContent={() =>
          IterateSEOLayoutExperient.get('behaviour') === 'variant' ? (
            <MapListSwitcher
              onClickLeft={() => {
                onSwitcherClick();
                toggleSpottyCat();
              }}
              onClickRight={() => {
                onSwitcherClick();
                toggleSpottyCat();
              }}
            />
          ) : null
        }
      />
    </header>
  );
};

Header.propTypes = {
  onSwitcherClick: PropTypes.func.isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired
};

export default Header;
